import { Grid, LinearProgress } from '@material-ui/core'
import { reduxForm, Field } from 'redux-form'
import { UpdateApplicationStatus } from '../../../actions/types'
import { SubmitFormButton } from '../../../components/Buttons'
import ErrorMessage from '../../../components/Error/ErrorMessage'
import { ReduxTextField } from '../../../components/FormInput/ReduxWrappers'
import { ReduxForm } from '../../../types/forms'

interface UpdateApplicationStatusFormProps extends ReduxForm {
  updateApplicationStatus: UpdateApplicationStatus
}

const UpdateApplicationStatusForm = ({
  updateApplicationStatus,
  handleSubmit,
  submitting,
  error
}: UpdateApplicationStatusFormProps) => (
  <form onSubmit={handleSubmit(updateApplicationStatus)}>
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Field
          fullWidth
          name='message'
          label='manual status message'
          component={ReduxTextField}
          multiline={true}
        />
      </Grid>
      <Grid item xs={12}>
        <SubmitFormButton label='Set manual status' submitting={submitting} />
      </Grid>
      <ErrorMessage error={error} />
      {submitting && <LinearProgress />}
    </Grid>
  </form>
)

export default reduxForm({
  form: 'UpdateApplicationStatusForm'
  // enableReinitialize: true,
  // destroyOnUnmount: false
})(UpdateApplicationStatusForm as any) as any
